module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "x_panel"
  }, [_c('div', {
    staticClass: "x_title"
  }, [_vm._t("title"), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('form', {
    staticClass: "form-horizontal",
    staticStyle: {
      "display": "inline"
    }
  }, [(_vm.filter && _vm.showPanel) ? _c('div', {
    class: [
      'col-md-4 input-group',
      _vm.filterText !== '' ? 'borderfix' : ''
    ]
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterText),
      expression: "filterText"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Filter"
    },
    domProps: {
      "value": (_vm.filterText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filterText = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.filterText !== '') ? _c('span', {
    class: [
      'input-group-btn'
    ]
  }, [_c('button', {
    staticClass: "btn btn-link btn-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.clearSearch()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  })])]) : _vm._e()]) : _vm._e()])]), _vm._v(" "), _c('ul', {
    staticClass: "nav navbar-right panel_toolbox"
  }, [_vm._t("toolbar-start"), _vm._v(" "), _vm._t("toolbar", function() {
    return [_c('li', [_c('a', {
      attrs: {
        "title": "Hide Panel Contents"
      },
      on: {
        "click": function($event) {
          return _vm.togglePanelDisply()
        }
      }
    }, [_c('i', {
      class: [
        'fa fa-chevron-up',
        _vm.showPanel ? 'fa-chevron-up' : 'fa-chevron-down'
      ]
    })])])]
  }), _vm._v(" "), _vm._t("toolbar-end")], 2), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })], 2), _vm._v(" "), (_vm.showPanel) ? _c('div', {
    staticClass: "x_content"
  }, [_vm._t("content")], 2) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cd8c8e4e","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Layout/Panel.vue
// module id = 346
// module chunks = 1